import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TimeReportType } from '@app/shared/types/models/reports/time-report';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-time-report-type-selector-dialog',
  templateUrl: './time-report-type-selector-dialog.component.html',
  imports: [MatDialogModule, TranslatePipe, UiDialogComponent, UiButtonComponent]
})
export class TimeReportTypeSelectorDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<TimeReportTypeSelectorDialogComponent, TimeReportType>);

  protected selectWorkTime(): void {
    this.dialogRef.close('WorkTime');
  }

  protected selectAbsence(): void {
    this.dialogRef.close('Absence');
  }

  protected cancel(): void {
    this.dialogRef.close();
  }
}
